import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

export const LicenseRestriction = (props) => {
  const [allow, setAllow] = useState(false)

  useEffect(() => {
    setAllow(props.license.isAllowedAPI(props.requires))
  }, [props.requires, props.license])

  const childrenWithProps = React.Children.map(props.children, child => {
    if (React.isValidElement(child)) {
      const childProps = {}
      // API check
      if(allow === false) {
        childProps['disabled'] = true
      }
      return React.cloneElement(child, childProps);
    }
    return child;
  });

  return <>{childrenWithProps}</>
}

const mapStateToProps = (state) => {
    return {
      'license': state.license
    }
}

export default connect(mapStateToProps, null)(LicenseRestriction)